import { mergeMap } from './mergeMap';
import { identity } from '../util/identity';
export function mergeAll(concurrent = Infinity) {
    return mergeMap(identity, concurrent);
}
